import { Injectable, OnDestroy, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { defaultIfEmpty, filter, merge, take, Subscription } from 'rxjs';

import { AppState, StorageService } from '@fcom/core';
import { loginIsOpen } from '@fcom/core/selectors/login.selector';
import { unsubscribe } from '@fcom/core/utils/unsubscribe';

import { JoinService } from '../../login/services/join.service';

export const WELCOME_BACK_MESSAGE_CLOSED_KEY = 'welcome-back-message-closed';

@Injectable()
export class WelcomeBackMessageService implements OnDestroy {
  private store$ = inject<Store<AppState>>(Store);
  private joinService = inject(JoinService);
  private storageService = inject(StorageService);

  private subscriptions: Subscription;

  constructor() {
    if (!this.storageService.SESSION.get(WELCOME_BACK_MESSAGE_CLOSED_KEY)) {
      this.subscriptions = merge(this.store$.pipe(loginIsOpen()), this.joinService.joinDialogOpen$)
        .pipe(filter(Boolean), take(1), defaultIfEmpty(false))
        .subscribe((_) => this.close());
    }
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }

  close(): void {
    this.storageService.SESSION.set(WELCOME_BACK_MESSAGE_CLOSED_KEY, true);
  }
}
